var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bige" }, [
    _c("section", { staticStyle: { "padding-top": "120px" } }, [
      _c("h1", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("ul", { staticClass: "accordion cont" }, [
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Pourquoi participer à IDTROC ?")]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Comment participer au dépôt IDTROC ?")]),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Quel type d'articles peut-on déposer ?")]),
          _vm._v(" "),
          _vm._m(2)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v(
              "\n          Faut-il être membre du programme de fidélité pour participer à\n          l'IDTROC ?\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(3)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v("Quels sont les magasins qui participent à IDTROC ?")
          ]),
          _vm._v(" "),
          _vm._m(4)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v(
              "\n          Quels sont les tarifs fixés pour les articles vendus à l’IDTROC ?\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _vm._m(8)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Y a-t-il une commission perçue sur les ventes ?")]),
          _vm._v(" "),
          _vm._m(9)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Quelle est la procédure pour les invendus ?")]),
          _vm._v(" "),
          _vm._m(10)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v("Que se passe-t-il si un article déposé a disparu ?")
          ]),
          _vm._v(" "),
          _vm._m(11)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v(
              "\n          Est-il possible d'échanger ou retourner un article IDTROC ?\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n          Non les articles IDTROC ne sont ni repris ni échangés. Bien que le\n          magasin fasse un contrôle qualité avant l'acceptation du dépôt et de\n          la mise en vente, il est important lors de l'achat, d'être vigilant\n          sur la qualité de chaque article ÏDTROC acheté.\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v(
              "\n          Quelles sont les conditions d'utilisation de la carte cadeau ?\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(12)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v(
              "\n          Mon contrat a été créé par le magasin, comment vais-je recevoir ma carte cadeau ?\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(13)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v(
              "\n          L’application plante, ne s'ouvre pas, ne répond pas, ne fonctionne pas correctement ?\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(14)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("A propos du Covid ?")]),
          _vm._v(" "),
          _vm._m(15)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Comment se connecter à l’application ?")]),
          _vm._v(" "),
          _vm._m(16)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v(
              "Je ne reçois pas le code par SMS pour valider ma connexion, que faire ?"
            )
          ]),
          _vm._v(" "),
          _vm._m(17)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Faut-il saisir l’indicatif pays ?")]),
          _vm._v(" "),
          _vm._m(18)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [
            _vm._v("Je reçois le code mais je suis directement connecté :")
          ]),
          _vm._v(" "),
          _vm._m(19)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("La photo des articles est-elle obligatoire ?")]),
          _vm._v(" "),
          _vm._m(20)
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.openClose } }, [
          _c("h3", [_vm._v("Comment supprimer mon compte IDTROC ?")]),
          _vm._v(" "),
          _vm._m(21)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _c("strong", [
          _vm._v(
            "\n              IDTROC a pour objectif de favoriser l'économie circulaire.\n            "
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Pour ce faire, nous proposons à nos clients membres du\n            programme de fidélité, et ce de manière totalement gratuite, un\n            dispositif de revente des vêtements de nos marques OKAÏDI–OBAÏBI,\n            de livres et de jouets OXYBUL dans nos magasins.\n          "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block" }, [
        _c("p", [_vm._v("IDTROC est un service singulier car il est :")]),
        _vm._v(" "),
        _c("ul", { staticClass: "list" }, [
          _c("li", [
            _c("strong", [
              _c("span", { staticClass: "special" }, [_vm._v("Pratique :")])
            ]),
            _vm._v(
              "\n                dépôt de tous les articles en une fois\n              "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [
              _c("span", { staticClass: "special" }, [_vm._v("Gratuit :")])
            ]),
            _vm._v(
              "\n                vente prise en charge par le magasin sans frais ni commission\n              "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [
              _c("span", { staticClass: "special" }, [_vm._v("Simple :")])
            ]),
            _vm._v("\n                prix fixé non négociable\n              ")
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [
              _c("span", { staticClass: "special" }, [_vm._v("Performant :")])
            ]),
            _vm._v(
              "\n                98% des déposants vendent un article ou plus\n              "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [
              _c("span", { staticClass: "special" }, [_vm._v("Sécurisé :")])
            ]),
            _vm._v(
              "\n                paiement garanti en carte cadeau\n              "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("strong", [
              _c("span", { staticClass: "special" }, [_vm._v("Solidaire :")])
            ]),
            _vm._v(
              "\n                possibilité de retirer ou donner ses invendus\n              "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "block" }, [
        _c("ol", { staticClass: "list" }, [
          _c("li", [
            _c("p", [
              _c("strong", [
                _vm._v(
                  "\n                    Pour les IDTROC OKAIDI-OBAIBI, OXYBUL ou IDKIDS, il faut être membre du programme de fidélité\n                  "
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                  Vous voulez adhérer au programme fidélité ?\n                  "
              ),
              _c("br"),
              _vm._v(" "),
              _c("strong", [
                _vm._v(
                  "\n                    Rendez-vous en magasin ou sur le site\n                  "
                )
              ]),
              _vm._v("\n                   :\n                  "),
              _c(
                "a",
                {
                  staticClass: "hyperlink",
                  attrs: {
                    href: "https://www.okaidi.fr/programme-fidelite-2",
                    title: "la fidélité okaidi",
                    rel: "noopener",
                    target: "_blank"
                  }
                },
                [
                  _vm._v(
                    "\n                    http://www.okaidi.fr/fidelite/\n                  "
                  )
                ]
              ),
              _vm._v("\n                  ou sur\n                  "),
              _c(
                "a",
                {
                  staticClass: "hyperlink",
                  attrs: {
                    href: "https://www.oxybul.com/programme-fidelite/",
                    title: "la fidélité Oxybul",
                    rel: "noopener",
                    target: "_blank"
                  }
                },
                [
                  _vm._v(
                    "\n                    https://www.oxybul.com/programme-fidelite\n                  "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(
                  "\n                    Pour les IDTROC Catimini, il faut être inscrit au fichier client.\n                  "
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(
                  "\n                    Rendez-vous en boutique ou sur le site\n                  "
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "hyperlink",
                  attrs: {
                    href: "https://www.catimini.com/fr-fr/connexion",
                    title: "page de connexion catimini",
                    rel: "noopener",
                    target: "_blank"
                  }
                },
                [
                  _vm._v(
                    "\n                    https://www.catimini.com/fr-fr/connexion\n                  "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Avant le début de la vente")]),
              _vm._v(
                ", télécharger\n                  l’application IDTROC ou retirer un kit d'étiquetage en magasin\n                  pour étiqueter vos articles avant le dépôt.\n                "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("Lors du dépôt")]),
              _vm._v(
                ", le magasin effectue un\n                  contrôle qualité et vous serez invités à cintrer (pour les\n                  articles textile) et ranger vos articles vous-même en rayon.\n                "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("De J+1 à J+3")]),
              _vm._v(
                " après la fin de la vente, vous\n                  avez le choix de reprendre vos invendus dans l'espace IDTROC\n                  (munissez-vous de votre contrat et d'une pièce d'identité)\n                  ou ne pas les retirer et de les donner au\n                  "
              ),
              _c("strong", [
                _vm._v(
                  "\n                    à l’association/organisme parrainé par le magasin.\n                  "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("strong", [_vm._v("À J+3")]),
              _vm._v(
                " après la fin de la vente, votre carte\n                  cadeau est créditée (soit collée sur le contrat, soit\n                  directement dans l’application si votre magasin est\n                  éligible). Présentez-vous en magasin avec votre contrat pour\n                  connaitre le montant. Le magasin pourra vous donner le\n                  détail de vos ventes. Si vous avez utilisé l’application,\n                  vous y retrouverez le détail de vos ventes.\n                "
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _c("strong", [_vm._v("IDTROC OKAÏDI – OBAÏBI :")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Seuls les vêtements avec l'étiquette de marque OKAÏDI ou\n            OBAÏBI et avec l'étiquette de taille (puce dans le col, étiquette\n            intérieur) sont acceptés, l'étiquette de composition n'est pas\n            obligatoire. Les vêtements doivent être en parfait état (propre,\n            repassé, sans tâche, ni bouloche, ni coloris passé/délavé, ni\n            bouton ou pression manquants, zip fonctionnel...). Les ensembles\n            sont à vendre séparément. Ne sont pas acceptés : chaussures,\n            sous-vêtements (hors body) et accessoires. Pour l'automne - hiver\n            : Articles de mi-saison et hiver, mais pas les articles plein été\n            (débardeurs, shorts légers…). Pour le printemps - été : Articles\n            de mi-saison et été, mais pas les articles hiver (col roulé,\n            velours, pull lourd, doudoune...) Pour permettre au plus grand\n            nombre de participer à l'IDTROC, le nombre de vêtements est limité\n            à 25 articles par contrat et à un contrat par membre du programme\n            fidélité. En cas de surstock prévisible, le magasin pourra refuser\n            la distribution de kits ou les dépôts.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("IDTROC CATIMINI :")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Seul les vêtements avec l'étiquette de marque CATIMINI et\n            avec l'étiquette de taille (puce dans le col, étiquette intérieur)\n            sont acceptés, l'étiquette de composition n'est pas obligatoire.\n            Les vêtements doivent être en parfait état (propre, repassé,\n            sans tâche, ni bouloche, ni coloris passé/délavé, ni bouton ou\n            pression manquants, zip fonctionnel...). Les ensembles sont à\n            vendre séparément. Ne sont pas acceptés : chaussures, sous-vêtements\n            (hors body) et accessoires. Pour l'automne - hiver: Articles de\n            mi-saison et hiver, mais pas les articles plein été (débardeurs,\n            shorts légers…). Pour le printemps - été : Articles de mi-saison\n            et été, mais pas les articles hiver (col roulé, velours, pull lourd,\n            doudoune...) Pour permettre au plus grand nombre de participer à\n            l'IDTROC, le nombre de vêtements est limité à 50 articles par\n            contrat et à un contrat par membre inscrit sur le fichier client.\n            En cas de surstock prévisible, le magasin pourra refuser la\n            distribution de kits ou les dépôts.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("Pour l’IDTROC LIVRES chez OXYBUL – ÏDKIDS :")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Seuls vos livres pour enfant et guides parentaux en PARFAIT\n            ETAT sont acceptés. Ne sont pas acceptés : les livres sales,\n            jaunis, déchirés, raturés, avec la mention « ne pas vendre » ou\n            gratuits, de collections trop anciennes, livres-cd, livres-puzzle\n            et livres coloriages.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [
          _vm._v("Pour l’IDTROC JEUX-JOUETS chez OXYBUL – ÏDKIDS :")
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Jeux et jouets acceptés : en parfait état de marche (piles\n            neuves…), propres et complets. Catégories acceptées : jouets\n            d’éveil, jeux de société, de construction, d’imitation, jeux\n            éducatifs et de plein air. Marques acceptées : marques Oxybul et\n            marques nationales.\n            "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "- Un jouet composé de plusieurs pièces doit être soit :\n            "
        ),
        _c("br"),
        _vm._v(
          "• dans l’emballage d’origine (obligatoire pour les jeux de\n            société) "
        ),
        _c("br"),
        _vm._v(
          "• dans un emballage transparent et hermétique\n            (pochette, box…) "
        ),
        _c("br"),
        _vm._v(
          "• assemblé proprement avec un scotch\n            transparent sans risque de détérioration au retrait. "
        ),
        _c("br"),
        _vm._v(
          "- Les\n            jouets textile doivent être lavés, propres, sans tâche ni\n            déchirure. "
        ),
        _c("br"),
        _vm._v(
          "- Les Lego, Duplo, Playmobil, Kapla… peuvent être\n            incomplets s’ils sont dans un emballage transparent et hermétique.\n            "
        ),
        _c("br"),
        _vm._v(
          "Ne sont pas acceptés : jouets à pile sans pile, puzzles > 50\n            pièces, poupées, peluches, articles roulants, trampolines,\n            portiques, aire de jeux, maisons et tentes, articles gonflables,\n            produits électriques et jeux multimédia, articles de loisirs\n            créatifs utilisés.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Pour les IDTROC Okaidi-Obaibi, Oxybul et IDKIDS : Oui, pour déposer vos articles IDTROC il faut être membre du\n            programme de fidélité, par contre\n            "
        ),
        _c("strong", [_vm._v("la vente est ouverte à tous")]),
        _vm._v(".\n          ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Pour les IDTROC Catimini : Il suffit de faire partie du fichier client!\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Pour l’IDTROC Okaïdi – Obaïbi, accédez à la liste des magasins\n            participants sur l’appli IDTROC ou\n            "
        ),
        _c(
          "a",
          {
            staticClass: "hyperlink",
            attrs: {
              href: "https://www.okaidi.fr/idtroc-4",
              target: "_blank",
              title: "liste des magasins okaidi participants",
              rel: "noopener"
            }
          },
          [_vm._v("\n            cliquez ici\n            ")]
        ),
        _vm._v(".\n          ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Pour l’IDTROC livres et jouets, accédez à la liste des magasins\n            participants sur l’appli IDTROC ou\n            "
        ),
        _c(
          "a",
          {
            staticClass: "hyperlink",
            attrs: {
              href: "https://www.oxybul.com/id-troc",
              target: "_blank",
              title: "liste des magasins Oxybul participants",
              rel: "noopener"
            }
          },
          [_vm._v("\n              cliquez ici\n            ")]
        ),
        _vm._v(".\n          ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Pour l'IDTROC Catimini, accédez à la liste des magasins participants sur l'appli IDTROC ou\n            "
        ),
        _c(
          "a",
          {
            staticClass: "hyperlink",
            attrs: {
              href: "https://www.catimini.com/fr-fr/website/465-idtroc",
              target: "_blank",
              title: "liste des magasins Catimini participants",
              rel: "noopener"
            }
          },
          [_vm._v("\n              cliquez ici\n            ")]
        ),
        _vm._v(".\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", [_vm._v("Pour OBAÏBI :")]),
      _vm._v(" "),
      _c("ul", { staticClass: "price-list" }, [
        _c("li", [
          _vm._v("\n              T Shirt, body, legging :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("2€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Short, jupe :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("3€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n              Pull, cardigan, sweat, chemise, pantalon :\n              "
          ),
          _c("span", { staticClass: "price-tag" }, [_vm._v("4€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Robe, salopette, pyjama :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("5€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Manteau léger :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("8€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Manteau hiver, gigoteuse :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("10€")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", [_vm._v("Pour OKAÏDI :")]),
      _vm._v(" "),
      _c("ul", { staticClass: "price-list" }, [
        _c("li", [
          _vm._v("\n              T-shirt, Legging :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("3€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n              Jupe, pull, chemise/ier, short :\n              "
          ),
          _c("span", { staticClass: "price-tag" }, [_vm._v("5€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Pantalon, pyjama :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("6€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Robe, salopette :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("7€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Blouson léger :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("12€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("\n              Blouson hiver :\n              "),
          _c("span", { staticClass: "price-tag" }, [_vm._v("15€")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", [_vm._v("Pour les livres chez OXYBUL – ÏDKIDS :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Les prix de revente IDTROC sont fixés en fonction de la taille du\n            livre.\n          "
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "price-list" }, [
        _c("li", [
          _vm._v(
            "\n              • Petits livres : 2 € (Livres 1er âge, souples (Mr et Mme, petit\n              ours brun, Tchoupi, …), de poche (Bibliothèque Rose et Verte,\n              Penelope, Premiers Romans, Max et Lili etc…), imagerie sonore\n              (sans CD)…)\n            "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n              Pantalon, jupe, pull, sweat, cardigan, chemise/sier, blouse\n              0/2 ans\n              "
          ),
          _c("span", { staticClass: "price-tag" }, [_vm._v("3€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n              • Moyens livres : 3 € (Bandes dessinées, imageries,\n              documentaires, livres jeu, romans, albums en dur, Ecole des\n              loisirs (Histoires à lire, Ecoledesmax.com...), guides pour\n              parents…)\n            "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n              Robe, salopette, barboteuse et pyjama 0/14 ans\n              "
          ),
          _c("span", { staticClass: "price-tag" }, [_vm._v("5€")])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n              • Grands livres : 5€ (Dictionnaires, encyclopédies, recueil de\n              contes…)\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h5", [_vm._v("Pour les jeux et jouets chez OXYBUL – ÏDKIDS :")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Les prix de revente IDTROC sont à fixer à -70%/-80% du prix\n            d’achat neuf suivant cette grille de prix : 2€, 3€, 4€, 5€, 7€,\n            10€, 15€, 20€\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Non, il n'y a aucune commission ni frais sur les ventes.\n            "
        ),
        _c("br"),
        _vm._v(" "),
        _c("strong", [
          _vm._v("\n              L'IDTROC est un service\n              "),
          _c("span", { staticClass: "special" }, [_vm._v("GRATUIT")]),
          _vm._v(
            ", dont le montant vendu est\n              reversé à 100% en carte cadeau.\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("ul", { staticClass: "list" }, [
        _c("li", [
          _vm._v(
            "\n              Le déposant a le choix de retirer ou donner tout ou une partie\n              des invendus au\n              "
          ),
          _c(
            "a",
            {
              staticClass: "hyperlink",
              attrs: {
                href:
                  "https://www.youtube.com/watch?v=35YedSx08Ac&feature=youtu.be",
                target: "_blank",
                title: "que deviennent les invendus avec le lovebag",
                rel: "noopener"
              }
            },
            [_vm._v("\n                LOVE BAG\n              ")]
          ),
          _vm._v(
            "\n              pour Okaïdi-Obaïbi ou les associations locales sélectionnées par\n              votre magasin Oxybul pour les jeux et jouets ou les livres.\n            "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n              Si vous souhaitez les retirer, aux dates indiquées (les 3 jours\n              suivant la fin de la vente), vous effectuez une recherche de vos\n              invendus dans l'espace IDTROC (munissez-vous de votre contrat et\n              d'une pièce d'identité).\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Le magasin fera tout son possible pour garantir un commerce sécurisé\n            mais ne pourra être tenu responsable de disparition ou détérioration\n            d'articles déposés.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Au moment du retrait de vos invendus, si un article est manquant,\n            le magasin ne peut être tenu responsable en cas de vols, pertes,\n            dégradations, ou détériorations des articles déposés.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            En cas d’anomalie avérée, vous recevrez une carte cadeau supplémentaire\n            du montant de l’article manquant (prix de vente initial) à J+10 de la\n            fin des ventes ÏDTROC.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("ul", { staticClass: "list" }, [
        _c("li", [
          _vm._v(
            "\n              La carte cadeau est valable 2 mois sur tous les articles (hors\n              articles ÏDTROC) en magasin et sur le web (lors du paiement,\n              choisir “Carte cadeau”, code carte = 19 premiers chiffres de\n              la carte cadeau, code scratch/pin/sécurité = 4 derniers chiffres\n              de la carte cadeau) et sur les promotions en cours.\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "Un mail vous sera envoyé avec votre carte cadeau à J+ 4 de la fin des ventes ÏDTROC."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("ul", { staticClass: "list" }, [
        _c("li", [
          _c("b", [_vm._v("Étape 1 :")]),
          _vm._v(
            " Redémarrez l'appareil et effectuez les mises à jour de l'application"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [_vm._v("Étape 2 :")]),
          _vm._v(
            " Si cela ne fonctionne pas, supprimez l'application et réinstallez- la."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [_vm._v("Étape 3 :")]),
          _vm._v(
            " Vous avez la possibilité de vous rendre en magasin qui pourra vous inscrire directement et vous remettre un jeu d'étiquettes"
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            Pour plus d’info pour Android : "),
        _c(
          "a",
          {
            attrs: {
              href: "https://support.google.com/googleplay/answer/2668665?hl=fr"
            }
          },
          [_vm._v("cliquez ici")]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            Pour plus d’info pour iOS : "),
        _c(
          "a",
          { attrs: { href: "https://support.apple.com/fr-fr/HT201398" } },
          [_vm._v("cliquez ici")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Les articles déposés sont mis en quarantaine 24H avant d’être proposés à la vente pour assurer la sécurité de tous.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "Pour se connecter, il suffit de choisir un IDTROC puis un magasin"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "Réessayez en vous assurant de la bonne saisie de votre N° de téléphone."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Il est possible de saisir l’indicatif pays ex : +336XXXXXXXX mais cela fonctionne aussi sans ex : 06XXXXXXXX.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Sur certains téléphones Androïd, le code est automatiquement intégré sans que vous ayez à le saisir :)\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            La photo n’est pas obligatoire par contre il y a pas mal d’avantages à l’ajouter :\n            poser la bonne étiquette sur le bon produit afin de pouvoir suivre vos ventes article par article,\n            faciliter la validation du dépôt en magasin et le réétiquetage par le magasin en cas de perte de l’étiquette.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            Depuis l'application mobile, allez dans « Paramètres », « Mon profil » et appuyer sur « Supprimer mon compte ».\n            Une fois validé, toutes vos données seront supprimées de notre base de données.\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-danger" }, [
        _vm._v(
          "\n            ATTENTION : Une fois votre compte supprimé, vous n'aurez plus accès à vos contrats, vos articles et vos cartes cadeaux.\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f44d9bd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f44d9bd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ.vue
// module id = null
// module chunks = 